import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LayoutServiceContextData } from '@sitecore-jss/sitecore-jss-angular';
import { Subscription } from 'rxjs';
import { ApiService } from '../../services/ApiService';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent implements OnInit, OnDestroy {
  @Input() errorContextData: LayoutServiceContextData;
  isEditing = false;
  private contextSubscription: Subscription;
  language: string;
  public sitecoreApiHost = environment.sitecoreApiHost;
  public sitecoreApiKey = environment.sitecoreApiKey;
  public action: string;
  heroErrorData: any;
  menuData: any;
  footerData: any;
  notfoundPagename: string;
  route : any;
  constructor(
    private router: Router,
    protected apiService: ApiService) {
  }

  ngOnInit(): void {
      //this.router.navigate(['/404-page']);
    this.notfoundPagename = "404-page";
    this.language = this.errorContextData?.context?.language;
	  if (this.language && this.language.toLocaleLowerCase() == 'el-gr'){
      this.language = 'el';
    }
    this.action = `/sitecore/api/layout/render/jss?item=%2F${this.notfoundPagename}%2F&sc_lang=${this.language}&sc_apikey=${this.sitecoreApiKey}&sc_site=eurobankequities`;
    this.apiService.fetchLayoutService<any[]>(this.action,"")
      .then(resp => {
        if (resp.status === 200) {
          var isFound = false;
          var url = "";
          var nameValueList = (((resp.data as any)['sitecore'].route.placeholders["jss-main"][0]?.fields as any)?.Redirects);
          nameValueList.forEach((element:any) => {
            if (window.location.pathname == element?.fields?.OldUrl?.value){
              isFound = true;
              url = element?.fields?.NewUrl?.value;
            }

            // var replacedElement = element.replace(/%2F/g, '/').replace(/%2f/g, '/');
            // var [key,value] = replacedElement.split("=");
            // if (window.location.pathname == key.trim()){
            //   isFound = true;
            //   url = value.trim();
            // }
          });
          if (isFound) {
            this.router.navigateByUrl(url);
          }
          else{
            this.route = (resp.data as any)["sitecore"].route;
          }
        }
      });

  }

  ngOnDestroy(): void {
    if (this.contextSubscription) {
      this.contextSubscription.unsubscribe();
    }
  }

}
